import { makeRequest } from "./proxyHelper";

const getNegBaseUrl = () => process.env.REACT_APP_NEGOTIATIONS_API_URL;
const getCostCenterBaseUrl = (urlEnding = '') => getNegBaseUrl() + '/cost_centers/' + urlEnding;

export const costCenterProxy = {
    async getBudgetsByTenantId(accessToken, tenantId) {
        let url = getCostCenterBaseUrl(`budget/${tenantId}`);
        return makeRequest(url, accessToken, tenantId);
    }
};

